var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_not_found"},[_vm._v(" お探しのページが見つかりません。"),_c('br'),_vm._v(" アドレスをお確かめのうえ、もう一度お試しください。 ")])}]

export { render, staticRenderFns }